



















import { Component, Prop, Vue } from "vue-property-decorator";
import { ButtonVariant, ErrorType } from "@/types";
import { createPartyPage } from "@/router";

@Component
export default class ErrorPage extends Vue {
  $enums = {
    ButtonVariant,
  };

  @Prop({ required: true }) errorType!: ErrorType;

  get message(): string {
    switch (this.errorType) {
      case ErrorType.PARTY_VALIDATION:
        return "the link to the party is invalid";

      case ErrorType.NOT_FOUND:
        return "the page you are looking for does not seem to exist";

      case ErrorType.UNKNOWN:
        return "something went wrong, not sure what though...";
    }

    function checkExhaustive(errorType: never): string {
      throw new Error(
        "Unhandled error type (add to switch above): " + errorType
      );
    }

    return checkExhaustive(this.errorType);
  }

  onClick(): void {
    this.$router.push(createPartyPage());
  }
}
